/*==================================
Author: Jimmy Patel
 * 
 * Created: 08 December, 2025
 *
 * Description: This file is mainly created for the animated section used in THE BRAND page.
 * */

document.addEventListener("DOMContentLoaded", function () {
    const banners = document.querySelectorAll(".banner");

    window.addEventListener("scroll", function () {
        banners.forEach((banner) => {
        const windowH = window.innerHeight;
        const scrollBelowMiddle = window.scrollY + (windowH * 2) / 3;
        const sectionMiddle = banner.offsetTop + banner.offsetHeight / 2;

        const heading = banner.querySelector(".banner__heading");
        const text = banner.querySelector(".banner__text");

        if (!heading || !text) return;

        if (scrollBelowMiddle > sectionMiddle) {
            heading.classList.remove("fade-in");
            text.classList.add("fade-in");
        } else {
            text.classList.remove("fade-in");
            heading.classList.add("fade-in");
        }
        });
    });
});
